import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';
import { permissionGuard } from './core/auth/permission.guard';
import { docArticleGuard } from './core/docs/docs.guard';
import { Shell } from './shell/shell';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Entrar · Unblock It',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'callback',
    title: 'Validando acesso · Unblock It',
    loadComponent: () => import('./pages/callback/callback').then((m) => m.Callback),
  },
  {
    path: 'logout',
    title: 'Saindo · Unblock It',
    loadComponent: () => import('./pages/logout/logout').then((m) => m.Logout),
  },
  {
    path: 'sessao-expirada',
    title: 'Sessão expirada · Unblock It',
    loadComponent: () => import('./pages/errors/session-expired').then((m) => m.SessionExpired),
  },
  {
    path: 'manutencao',
    title: 'Manutenção · Unblock It',
    loadComponent: () => import('./pages/errors/maintenance').then((m) => m.Maintenance),
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'visao-geral', pathMatch: 'full' },
      {
        path: 'visao-geral',
        title: 'Visão geral · Unblock It',
        loadComponent: () => import('./pages/overview/overview').then((m) => m.Overview),
      },
      {
        path: 'simulador',
        title: 'Simulador · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['simulador:read'] },
        loadComponent: () => import('./pages/simulador/simulador').then((m) => m.Simulador),
      },
      {
        path: 'consulta-cnpj',
        title: 'Consulta de CNPJ · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['cnpj:read'] },
        loadComponent: () => import('./pages/consulta-cnpj/consulta-cnpj').then((m) => m.ConsultaCnpj),
      },
      {
        path: 'rtc',
        title: 'Backbone RTC · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['rtc:read'] },
        loadComponent: () => import('./pages/rtc/projects').then((m) => m.RtcProjects),
      },
      {
        path: 'rtc/metodologia',
        title: 'Metodologia RTC · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['rtc:read'] },
        loadComponent: () => import('./pages/rtc/methodology').then((m) => m.RtcMethodology),
      },
      {
        path: 'rtc/modelo',
        title: 'Modelo de projeto · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['rtc:execute'] },
        loadComponent: () => import('./pages/rtc/template').then((m) => m.RtcTemplate),
      },
      {
        path: 'rtc/portfolio',
        title: 'Portfólio RTC · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['rtc:read'] },
        loadComponent: () => import('./pages/rtc/portfolio').then((m) => m.RtcPortfolio),
      },
      {
        path: 'rtc/:id',
        title: 'Projeto RTC · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['rtc:read'] },
        loadComponent: () => import('./pages/rtc/board').then((m) => m.RtcBoard),
      },
      {
        path: 'usuarios',
        title: 'Usuários · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['usuarios:read'] },
        loadComponent: () => import('./pages/users/users').then((m) => m.Users),
      },
      {
        path: 'usuarios/novo',
        title: 'Convidar usuário · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['usuarios:create'] },
        loadComponent: () => import('./pages/user-form/user-form').then((m) => m.UserForm),
      },
      {
        path: 'usuarios/:id/editar',
        title: 'Editar usuário · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['usuarios:update'] },
        loadComponent: () => import('./pages/user-form/user-form').then((m) => m.UserForm),
      },
      {
        path: 'catalogo',
        title: 'Catálogo de Módulos · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['permissoes:read'] },
        loadComponent: () => import('./pages/catalog/catalog').then((m) => m.Catalog),
      },
      {
        path: 'uso-simulador',
        title: 'Uso do Simulador · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['simulador-uso:read'] },
        loadComponent: () => import('./pages/uso-simulador/uso-simulador').then((m) => m.UsoSimulador),
      },
      {
        path: 'prompts-ia',
        title: 'Prompts de IA · Unblock It',
        canActivate: [permissionGuard],
        data: { permissions: ['ai-prompts:read'] },
        loadComponent: () => import('./pages/ai-prompts/ai-prompts').then((m) => m.AiPrompts),
      },
      {
        path: 'configuracoes',
        title: 'Configurações · Unblock It',
        loadComponent: () => import('./pages/settings/settings').then((m) => m.Settings),
      },
      {
        path: 'documentacao',
        title: 'Documentação · Unblock It',
        loadComponent: () => import('./pages/docs/docs').then((m) => m.Docs),
      },
      {
        path: 'documentacao/:slug',
        title: 'Documentação · Unblock It',
        canActivate: [docArticleGuard],
        loadComponent: () => import('./pages/docs/docs-article').then((m) => m.DocsArticle),
      },
      {
        path: 'acesso-negado',
        title: 'Acesso negado · Unblock It',
        loadComponent: () => import('./pages/errors/forbidden').then((m) => m.Forbidden),
      },
      {
        path: 'erro',
        title: 'Erro · Unblock It',
        loadComponent: () => import('./pages/errors/server-error').then((m) => m.ServerError),
      },
      {
        path: '**',
        title: 'Página não encontrada · Unblock It',
        loadComponent: () => import('./pages/errors/not-found').then((m) => m.NotFound),
      },
    ],
  },
];
